import React, { useEffect, useState } from 'react';
import {
  Container,
  Box,
  Grid,
  Typography,
  ToggleButtonGroup,
  ToggleButton
} from '@mui/material';

import subscriptionServices from '../../services/subscription-services';
import SubscriptionCard from './components/SubscriptionCard';

const PLAN_UI_CONFIG = {
  demo: {
    color: '#e4a4b8',
    description: 'Agende una cita para probar funcionalidades'
  },
  emprendedor: {
    color: '#e5a151',
    description: 'Ideal para comenzar con despachos simples'
  },
  pyme: {
    color: '#b3d4d2',
    description: 'Pensado para operaciones logísticas en crecimiento'
  },
  pro: {
    color: '#7dbf8e',
    description: 'Solución avanzada para operaciones a gran escala'
  }
};

export default function SubscriptionsIndex() {
  const [billingCycle, setBillingCycle] = useState('annual');
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const data = await subscriptionServices.getSubscriptionPlans();

        const normalizedPlans = data.map((plan) => {
          const ui = PLAN_UI_CONFIG[plan.slug] || {};

          return {
            ...plan,
            color: ui.color || '#ccc',
            description: ui.description || ''
          };
        });

        setPlans(normalizedPlans);
      } catch (error) {
        console.error('Error loading subscription plans', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: { xs: 3, md: 5 } }}>
        <Typography align="center">
          Cargando planes...
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 3, md: 5 } }}>
      <Box mb={4} textAlign="center">
        <Typography
          id="subs-title"
          variant="h1"
          component="h1"
          gutterBottom
          fontWeight={800}
        >
          Planes de Suscripción Anual
        </Typography>

        <Typography variant="body1" color="text.secondary" mb={2}>
          Elige el plan que mejor se adapte a tus necesidades logísticas.
        </Typography>

        <ToggleButtonGroup
          value={billingCycle}
          exclusive
          onChange={(e, val) => val && setBillingCycle(val)}
          sx={{ mb: 4 }}
        />
      </Box>

      {plans.length > 0 && (
        <Grid container spacing={3} justifyContent="center">
          {plans.map((plan) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={3}
              key={plan.id}
            >
              <SubscriptionCard
                plan={plan}
                billingCycle={billingCycle}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
}
